import type { AppIconProps } from '../Icons.types';
import { getClassNames } from '../Icons.utils';
import styles from './LockOff.module.scss';

export const AppLockOffIcon = (props: AppIconProps) => {
  const { className, ...rest } = props;
  const classNames = getClassNames(styles.icon, className);

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      className={classNames}
    >
      <path
        d="M4.86914 6.29837V4.86704V4.8537C4.87647 3.1777 6.24047 1.8257 7.91581 1.83304C8.90279 1.83304 9.77987 2.30459 10.334 3.03464"
        stroke="#737781"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.456 14.1663H5.36198C3.96598 14.1663 2.83398 13.035 2.83398 11.6383V8.77898C2.83398 7.38231 3.96598 6.25098 5.36198 6.25098H10.456C11.852 6.25098 12.984 7.38231 12.984 8.77898V11.6383C12.984 13.035 11.852 14.1663 10.456 14.1663Z"
        stroke="#737781"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9082 9.46875V10.9494"
        stroke="#737781"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
